import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import Endereco from '../models/endereco.model.ts';
import BrowserUtils from '../utils/browser-utils';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class EnderecoService {

  constructor(
    private http: HttpClient,
    private apiService: ApiService
  ) { }

  async buscarEnderecoPorCep(cep: string): Promise<Endereco> {

     const path = this.apiService.getEndpoint({
      apiKey: 'vv-cred-geolocalizacao',
      path: `/endereco/cep?Cep=${cep}`,
      oldBrowserFallbackPath: `/cep?Cep=${cep}`
    })
    const response = await this.http.get<{ enderecoCep: Endereco }>(path).toPromise();
    return response?.enderecoCep;
  }

  get apiUrlService(): string {
    if (BrowserUtils.isOldFirefox()) {
      return `${environment.cdccorpApiURLService}/v1`;
    }

    return `${environment.apiURLService}/v1`;
  }

}
